<ion-content fullscreen>
  <app-auth-template [title]="registerProps.signUp">
    <form
      #register="ngForm"
      (ngSubmit)="onRegister(register)">
      <ion-item-group class="p-4">
        <!-- USERNAME -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(username.dirty || username.touched) && username.errors">
          <ion-input
            #username="ngModel"
            type="text"
            placeholder="Username"
            name="username"
            ngModel>
          </ion-input>
          <ion-button
            fill="clear"
            slot="end"
            (click)="username.reset()">
            <ion-icon name="close-outline">
            </ion-icon>
          </ion-button>
        </ion-item>
        <div
          *ngIf="(username.dirty || username.touched) && username.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="username.errors?.required">
            {{ registerProps.usernameRequired }}
          </span>
        </div>

        <!-- EMAIL -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(email.dirty || email.touched) && email.errors">
          <ion-input
            #email="ngModel"
            type="email"
            placeholder="Email"
            name="email"
            required
            email
            ngModel>
          </ion-input>
          <ion-button
            fill="clear"
            slot="end"
            (click)="email.reset()">
            <ion-icon name="close-outline">
            </ion-icon>
          </ion-button>
        </ion-item>
        <div
          *ngIf="(email.dirty || email.touched) && email.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="email.errors?.required">
            {{ registerProps.emailRequired }}
          </span>
          <span *ngIf="email.errors?.email">
            {{ registerProps.emailInvalid }}
          </span>
        </div>

        <!-- PASSWORD -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(password.dirty || password.touched) && password.errors">
          <ion-input
            #password="ngModel"
            placeholder="Password"
            name="password"
            required
            ngModel
            [type]="showPassword ? 'text' : 'password'">
          </ion-input>
          <div
            slot="end"
            class="fx-row">
            <ion-button
              fill="clear"
              slot="icon"
              (click)="showPassword = !showPassword">
              <ion-icon [name]="showPassword ? 'eye' : 'eye-off'">
              </ion-icon>
            </ion-button>
            <ion-button
              fill="clear"
              slot="icon"
              (click)="password.reset()">
              <ion-icon name="close-outline">
              </ion-icon>
            </ion-button>
          </div>
        </ion-item>
        <div
          *ngIf="(password.dirty || password.touched) && password.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="password.errors?.required">
            {{ registerProps.passwordRequired }}
          </span>
        </div>

        <!-- RE-PASSWORD -->
        <ion-item
          class="radius-4 mt-6"
          lines="full"
          [class.error]="(repassword.dirty || repassword.touched) && repassword.errors">
          <ion-input
            #repassword="ngModel"
            placeholder="Confirm password"
            name="repassword"
            required
            ngModel
            appConfirmPassword
            [confirmPassword]="password.value"
            [type]="showRePassword ? 'text' : 'password'">
          </ion-input>
          <div
            slot="end"
            class="fx-row">
            <ion-button
              fill="clear"
              slot="icon"
              (click)="showRePassword = !showRePassword">
              <ion-icon [name]="showRePassword ? 'eye' : 'eye-off'">
              </ion-icon>
            </ion-button>
            <ion-button
              fill="clear"
              slot="icon"
              (click)="repassword.reset()">
              <ion-icon name="close-outline">
              </ion-icon>
            </ion-button>
          </div>
        </ion-item>
        <div
          *ngIf="(repassword.dirty || repassword.touched) && repassword.errors"
          class="text-red-500 body-3 mt-1 ml-1 pos-abs">
          <span *ngIf="repassword.errors?.required">
            {{ registerProps.confirmPasswordRequired }}
          </span>
          <span *ngIf="repassword.errors?.confirmPassword">
            {{ registerProps.passwordsDoNotMatch }}
          </span>
        </div>
      </ion-item-group>
      <ion-button
        class="mx-3 mb-2 ion-button-grey"
        expand="block"
        type="submit"
        [disabled]="register.invalid || register.pending">
        {{ registerProps.signUp }}
      </ion-button>
      <ion-button
        class="mx-3 mb-2 text-grey-500"
        expand="block"
        fill="clear"
        [replaceUrl]="true"
        [routerLink]="['../login']">
        {{ registerProps.login }}
      </ion-button>
    </form>
  </app-auth-template>
</ion-content>
